import { mode } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    return {
        textAlign: 'left',
        p: '0.875rem 1rem',
        m: 6,
        bg: mode('gray.600', 'gray.100')(props),
        color: mode('white', 'gray.600')(props),
        borderRadius: 'base',
        boxShadow: 'md',
    };
};
const getReverseStyle = (props) => {
    return {
        ...getBaseStyle(props),
        bg: mode('gray.100', 'gray.600')(props),
        color: mode('gray.600', 'white')(props),
    };
};
const variants = {
    base: getBaseStyle,
    reverse: getReverseStyle,
};
export default {
    variants,
    baseStyle: getBaseStyle,
    defaultProps: {
        variant: 'base',
    },
};
//# sourceMappingURL=snackbar.js.map